import { RatePostSchema } from "callable-data-objects";
import { CallableInput } from "Components/Shared";
import FormSubmit from "Components/Shared/FormSubmit";
import { Field, Formik } from "formik";
import { useRatingTable } from "Hooks/Endpoints";
import React from "react";
import { Card, Container, Form, Header } from "semantic-ui-react";
import TimeProfileSelect from "./TimeProfileSelect";

const CreateRateForm = () => {
  const { saveRate, createRate, uncreateRate } = useRatingTable();
  return (
    <Container fluid style={{ padding: "20px" }}>
      <Header as='h1'>Create Rate</Header>
      <Card fluid>
        <Card.Content>
          <Formik
            validateOnChange={false}
            initialValues={createRate}
            validationSchema={RatePostSchema}
            onSubmit={(values, actions) => {
              saveRate(values);
            }}
          >
            {({ handleSubmit, errors, validateField }) => (
              <Form onSubmit={handleSubmit}>
                <Field name='caller' label='Caller' component={CallableInput} />
                <Field name='called' label='Called' component={CallableInput} />
                <TimeProfileSelect name='timeProfile' label='Time Profile' />
                <Field
                  name='billAfterDuration'
                  label='Bill After'
                  type='number'
                  component={CallableInput}
                />
                <Field
                  name='minDuration'
                  label='Min Duration'
                  type='number'
                  component={CallableInput}
                />
                <Field
                  name='price'
                  label='Price'
                  type='number'
                  component={CallableInput}
                />
                <Field
                  name='setup'
                  label='Setup'
                  type='number'
                  component={CallableInput}
                />
                <FormSubmit
                  name='Create'
                  errors={errors}
                  onCancel={() => uncreateRate()}
                />
              </Form>
            )}
          </Formik>
        </Card.Content>
      </Card>
    </Container>
  );
};

export default CreateRateForm;
